<template>
  <v-row class="row interviewD">
    <div class="col-12 flexBlock time-block">
      <div class="flexBlock">
        <v-switch
          style="width: 150px"
          color="primary"
          v-model="showMarks"
          label="Оценки"
        >
        </v-switch>
      </div>
    </div>
    <div class="col-12 col-md-5">
      <div class="interview-card-custom detail-card">
        <div class="container-block">
          <div class="flex">
            <div class="img-container"> 
              <img v-if="typeof data.avatar != undefined && data.avatar != '' && data.avatar != null"
                :src="data.avatar"
              />
              <img v-else
                src="@/assets/img/no-foto.png"
              />
            </div>
            <div class="container-interview-title">
              <span class="radius-text">Департамент</span>
              <span class="title-interview"> {{ data.name }} {{ data.lastName }} {{ data.secondName }} </span>
              <p>Кандидат</p>
            </div>
            
          </div>

          <p>Время начала интервью: <b>13.10.2023 17:32</b></p>

          <hr>
          <div class="card-info">
            <h5>
              E-mail
              <br />
              <small v-if="data.email != undefined && data.email != '' && data.email != null">{{ data.email }}</small>
              <small v-else>нет</small>
            </h5>
            <h5>
              Telegram
              <br />
              <small v-if="data.telegram != undefined && data.telegram != '' && data.telegram != null">{{ data.telegram }}</small>
              <small v-else>нет</small>
            </h5>
            <h5>
              Телефон
              <br />
              <small v-if="data.phone != undefined && data.phone != '' && data.phone != null">{{ data.phone }}</small>
              <small v-else>нет</small>
            </h5>
            <h5>
              Мобильный
              <br />
              <small v-if="data.mobile != undefined && data.mobile != '' && data.mobile != null">{{ data.mobile }}</small>
              <small v-else>нет</small>
            </h5>
          </div>
        </div>

        <v-expansion-panels multiple class="custom-list">

          <v-expansion-panel>
            <v-expansion-panel-header>Инициатор интервью</v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-card class="user-card">
                <template v-slot:body>
                  <v-list>
                    <v-list-item v-for="item in data.heads" :key="item.id">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name + ' ' + item.lastName"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-avatar>
                        <img v-if="item.avatar != null && item.avatar != '' &&  item.avatar != undefined" :src="item.avatar">
                        <img v-else src="@/assets/img/no-foto.png">
                      </v-list-item-avatar>
                    </v-list-item>
                  </v-list>
                </template>
              </user-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Участники</v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-card class="user-card">
                <template v-slot:body>
                  <v-list>
                    <v-list-item v-for="item in members" :key="item.id">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name + ' ' + item.lastName"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-avatar>
                        <img v-if="item.avatar != null && item.avatar != '' &&  item.avatar != undefined" :src="item.avatar">
                        <img v-else src="@/assets/img/no-foto.png">
                      </v-list-item-avatar>
                    </v-list-item>
                  </v-list>
                </template>
              </user-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Руководители</v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-card class="user-card">
                <template v-slot:body>
                  <v-list>
                    <v-list-item v-for="item in data.heads" :key="item.id">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name + ' ' + item.lastName"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-avatar>
                        <img v-if="item.avatar != null && item.avatar != '' &&  item.avatar != undefined" :src="item.avatar">
                        <img v-else src="@/assets/img/no-foto.png">
                      </v-list-item-avatar>
                    </v-list-item>
                  </v-list>
                </template>
              </user-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Подчиненные</v-expansion-panel-header>
            <v-expansion-panel-content>
              <user-card class="user-card">
                <template v-slot:body>
                  <v-list>
                    <v-list-item v-for="item in data.subordinates" :key="item.id">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name + ' ' + item.lastName"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-avatar>
                        <img v-if="item.avatar != null && item.avatar != '' && item.avatar != undefined" :src="item.avatar">
                        <img v-else src="@/assets/img/no-foto.png">
                      </v-list-item-avatar>
                    </v-list-item>
                  </v-list>
                </template>
              </user-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Загруженные файлы</v-expansion-panel-header>
            <v-expansion-panel-content >
              <user-card class="user-card">
                <template v-slot:body>
                  <div class="container-tab" >
                    <table>
                      <tr>
                        <td class="custom-i" v-for="(file) in data.files" :key="file">
                          <a :href="rootUrl + file.filePath" target="_blank" :title="file.realFileName">
                            <i v-if="file.fileExtension == 'doc' || file.fileExtension == 'docx'" class="fa fa-file-word-o"></i>
                            <i v-else-if="file.fileExtension == 'xls' || file.fileExtension == 'xlsx'" class="fa fa-file-excel-o"></i>
                            <i v-else-if="file.fileExtension == 'png' || file.fileExtension == 'jpg' || file.fileExtension == 'jpeg'" class="fa fa-file-image-o"></i>
                            <i v-else-if="file.fileExtension == 'pdf'" class="fa fa-file-pdf-o"></i>
                            <i v-else-if="file.fileExtension == 'doc'" class="fa fa-file-text-o"></i>
                            <i v-else class="fa fa-file-o"></i>
                            <span>{{ file.realFileName }}</span>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </div>
                </template>
              </user-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>

      </div>
    </div>
    <div class="col-12 col-md-7">
      <div class="user-custom-skills">
        <div class="user-cards-competentions hard">
          <div class="group-skills">
            <div class="container-title">
              <h3 class="un-hover" @click="goToCompetentions(hardSkills.tag)">{{hardSkills.title}}</h3>
            </div>
            <v-expansion-panels multiple>
              <v-expansion-panel v-for="(area) in hardSkills.areas" :key="area.id">
                <v-expansion-panel-header class="title-skill">
                  <div class="in-container">
                    <div class="interview-title">
                      <h3>{{area.element.title}}</h3>
                      <p>{{area.element.description}}</p>
                    </div>
                    <v-footer v-if="showMarks" class="mb-0 bg-none">
                      <marks-list-second-variant></marks-list-second-variant>
                    </v-footer>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="interview-content">
                    <v-expansion-panels multiple>
                      <v-expansion-panel v-for="(competency) in area.items" :key="competency.id">
                        <v-expansion-panel-header class="title-skill">
                          <div class="in-container">
                            <div class="interview-title">
                              <h3>{{competency.title}}</h3>
                              <p>{{competency.description}}</p>
                            </div>
                            <v-footer v-if="showMarks" class="mb-0 bg-none">
                              <marks-list-second-variant></marks-list-second-variant>
                            </v-footer>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="interview-content">
                            <v-expansion-panels multiple>
                              <v-expansion-panel v-for="(theme) in competency.items" :key="theme.id">
                                <v-expansion-panel-header class="title-skill">
                                  <div class="in-container">
                                    <div class="interview-title">
                                      <h3>{{theme.title}}</h3>
                                      <p>{{theme.description}}</p>
                                    </div>
                                    <v-footer v-if="showMarks" class="mb-0 bg-none">
                                      <marks-list-second-variant></marks-list-second-variant>
                                    </v-footer>
                                  </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <div class="interview-content">
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <!-- <user-card class="user-card">
                      <template v-slot:body>
                        <categories
                          :interviewBlocks="interviewBlocks"
                          :items="area.items"
                        >
                        </categories>
                      </template>
                    </user-card> -->
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
    </div>
  </v-row>

</template>
<script>
import UserCard from "./UserProfileTeamplate/UserCard.vue";
import CategoryLayout from "../layout/categories/CategoryLayout.vue";
import Categories from "../components/Catergories/Categories.vue";
import GlobalRequest from "../plugins/globalRequest"
import MarksListSecondVariant from "../components/MarksListSecondVariant";

export default {
  name:"Detail",
  components: {
    UserCard,
    CategoryLayout,
    Categories,
    GlobalRequest,
    MarksListSecondVariant
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      interviewBlocks: true,
      preloader: true,
      data: {},
      items: {},
      members: {},
      dataCategory: [],
      hardSkills: [],
      softSkills: [],
      flag: false,
      userID: 28,
      showMarks: false,
      rootUrl: process.env.VUE_APP_FILE_URL
    };
  },
  methods: {
    goToCompetentions(type) {
      this.$router.push({
        name: 'areasLayout',
        query: {
          userID: this.data.id,
          typeSkill: type,
          back: this.$route.name
        }
      })
    },
    goBack() {
      this.$router.push({
        name: this.$route.query.back,
        query: this.$route.query
      })
    },
    async getData() {

      let resultI = await GlobalRequest.request("/user/list", "GET");
      this.items = resultI.data
      for(let i = 0; i < 6; i++) {
        this.members[i] = this.items[i]
      }

      let res = await GlobalRequest.request("/user/" + this.userID, "GET")
      this.data = res.data

      if(typeof this.data.heads == "undefined") this.data.heads = []
      if(typeof this.data.subordinates == "undefined") this.data.subordinates = []
      if(typeof this.data.files == "undefined") this.data.files = []

      console.log(this.data)

      //Компетенции
      let result = await GlobalRequest.request("/user/" + this.data.id + "/skills", "GET")
      this.hardSkills = result.data.hardSkills
      this.softSkills = result.data.softSkills

      for (let i in this.hardSkills.areas) {
        let res = await GlobalRequest.request("/element/" + this.hardSkills.areas[i].element.id, "GET")
        this.hardSkills.areas[i].items = res.data.items
        for ( let j in this.hardSkills.areas[i].items) {
          let item = this.hardSkills.areas[i].items[j]
          let result = await GlobalRequest.request("/element/" + item.id, "GET")
          item.items = result.data.items
        }
      }
      console.log("888888888888")
      console.log(this.hardSkills)

      for (let i in this.softSkills.areas) {
        let res = await GlobalRequest.request("/element/" + this.softSkills.areas[i].element.id, "GET")
        this.softSkills.areas[i].items = res.data.items
      }

      

      this.flag = true;
      this.preloader = false;
    },
  },
};
</script>

<style>


</style>
